var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "root" }, [
      _c("div", { staticClass: "stripe" }, [
        _vm._v("\n    Seja muito bem-vindo!\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("img", { attrs: { src: "static/dashboard/announcement.svg" } }),
        _vm._v(" "),
        _c("div", { staticClass: "discount" }, [
          _vm._v("\n      Utilize o cupom "),
          _c("b", [_vm._v("PRIMEIRA10OFF")]),
          _vm._v(" e garanta "),
          _c("b", { staticClass: "discount-amount" }, [
            _vm._v("10% de desconto")
          ]),
          _vm._v(" na sua primeira compra.\n\n      "),
          _c("div", { staticClass: "restriction" }, [
            _vm._v(
              "\n        Limite de uma utilização por cpf. Cupom não cumulativo com outros cupons.\n      "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c7f173c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7f173c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banners/BannerFirstOrder.vue
// module id = null
// module chunks = 